const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type Period = 'day' | 'week' | 'month' | 'year';
// ─── Types for API responses ──────────────────────────────────────────────────

interface AnalyticsData {
  revenue: {
    current: number;
    previous: number;
  };
  patients: {
    current: number;
    previousDelta: number;
  };
  bookings: {
    current: number;
    previous: number;
    completionRate: number;
  };
  newPatients: {
    current: number;
    previous: number;
  };
}
interface RevenueTrendPoint {
  label: string;
  revenue: number;
}
interface BookingCategory {
  name: string;
  count: number;
  fill: string;
}

// ─── Fallback mock data for new businesses with no data ──────────────────────